import React from 'react';
import Card from './Card';

/**
 * Card with a title bar and slot for chart content.
 * Title styled as small uppercase tracking-wider for an executive feel.
 */
function ChartCard({ title, subtitle, action, children, className = '', bodyClassName = 'p-5' }) {
  return (
    <Card className={className}>
      <div className="px-5 py-4 border-b border-slate-200 dark:border-slate-700/60 flex items-start justify-between gap-4">
        <div className="min-w-0">
          <h3 className="text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">
            {title}
          </h3>
          {subtitle && (
            <p className="text-xs text-slate-400 dark:text-slate-500 mt-1 truncate">{subtitle}</p>
          )}
        </div>
        {action && <div className="flex-shrink-0">{action}</div>}
      </div>
      <div className={bodyClassName}>{children}</div>
    </Card>
  );
}

export default ChartCard;
